var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box } from '@material-ui/core';
import { Formik } from 'formik';
import React from 'react';
import ReservationCard from '../../components/ReservationCard';
var UserInformationCard = function (_a) {
    var place = _a.place, date = _a.date, onSubmit = _a.onSubmit, initialValues = _a.initialValues, description = _a.description, validationSchema = _a.validationSchema, Form = _a.Form, submissionDisabled = _a.submissionDisabled;
    return (React.createElement(ReservationCard, { header: true, place: place, date: date },
        React.createElement(Box, null,
            description && React.createElement(Box, null, description),
            React.createElement(Formik, { onSubmit: onSubmit, validateOnMount: true, initialValues: initialValues !== null && initialValues !== void 0 ? initialValues : {}, render: function (props) { return (React.createElement(Form, __assign({}, props, { onSubmit: onSubmit, submissionDisabled: submissionDisabled }))); }, validationSchema: validationSchema }))));
};
export default UserInformationCard;
//# sourceMappingURL=index.js.map